<div class="fixed-panel modal" [ngClass]="{open: toggler.show}">
    <div class="content">
        <div class="content__header">
            <i class="material-icons icon" (click)="toggler.close()">close</i>
        </div>
        <div class="row">
            <div class="col-12 col-lg-6 left-col">
                <onwac-calendar 
                [excludedDays]="excludedDays"
                [allowOldDates]="false"
                (onDaySelected)=onDaySelected($event)
                (onCalendarChange)="onCalendarChange($event)"></onwac-calendar>
            </div>
            <div class="col-12 col-lg-6 right-col">
                <div *ngIf="!selectedDay" class="d-flex justify-content-center align-items-center h-100 w-100 text-center">{{'MEETING.help' | translate}}</div>
                <ng-container *ngIf="selectedDay">
                    <div class="day-viewer">
                        <div class="today">{{ 'MEETING.today' | translate }}, {{currentDate | date:'MMMM d'}}.</div>
                        <div class="selected-date">Meeting {{selectedDay | date:'MMMM d'}}</div>
                    </div>
    
                    <div class="schedule-range-wrapper">
                        <div class="title">{{ 'MEETING.availableHours' | translate }}</div>
                        <div class="schedule-range">
                            <div class="schedule-item" *ngFor="let range of schedule.scheduleRows"
                            [ngClass]="{
                            'available': range.availability == 1,
                            'taken': range.availability == 0,
                            'selected': range === selectedRange}"
                            (click)="selectSchedule(range)">
                                <div class="range">
                                    {{range.start | date:'HH:mm'}} - {{range.end | date:'HH:mm'}}
                                </div>
                                <div class="availability">
                                    <ng-container *ngIf="range === selectedRange;else notSelected">
                                        <span>{{'MEETING.scheduleAvailability.selected' | translate}}</span>
                                    </ng-container>
                                    <ng-template #notSelected>
                                        <span *ngIf="range.availability == 0">{{'MEETING.scheduleAvailability.taken' | translate}}</span>
                                        <span *ngIf="range.availability == 1">{{'MEETING.scheduleAvailability.available' | translate}}</span>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div class="button-row">
                        <onwac-button [text]="'FUNNEL.dealPage.triggers.buttons.meeting' | translate" [disabled]="!selectedRange" (click)="callback()"></onwac-button>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="overlay" *ngIf="toggler.show" (click)="toggler.close()"></div>
</div>

